import GxBlackButtonSmall from "@/app/components/common/actions/buttons/GxBlackButtonSmall";
import { useToken } from "@/app/services/context/TokenContext";
import {
  DATA_GIF_PATH,
  ICON_BASE_PATH,
  IMAGE_BASE_PATH,
} from "@/app/utils/config";
import { redirectToGrowXLogout } from "@/app/utils/loginservice/redirectToGrowXLogout";

type DialogSuccessfullyProps = {
  open: boolean;
  close: () => void;
  type: "true" | "";
  text: string;
};

const DialogSuccessfully = ({
  open,
  close,
  text,
  type,
}: DialogSuccessfullyProps) => {
  if (!open) return null;

  const { logout } = useToken();

  const handleLogout = () => {
    setTimeout(redirectToGrowXLogout, 0);
    logout();
  };

  return (
    <div className="gx-technicalmodal-overlay">
      <div className="gx-technicalmodal-container">
        <button
          className="gx-dialog-close-button gx-technicalmodal-close"
          onClick={close}
        >
          <img
            className="gx-icon-primary"
            src={`${ICON_BASE_PATH}close.svg`}
            alt="Close"
          />
        </button>

        <div className="grid grid-cols-12 gap-2">
          <div className="col-span-12">
            <div className="gx-consents-technicalsuccess">
              <img src={`${DATA_GIF_PATH}success.gif`} alt="Success" />
            </div>
          </div>

          <div className="col-span-12 mb-2.5">
            <div className="gx-dialog-title-h2">
              <h2 className="gx-h2-26-l leading-8 text-center">
                {text.split(" ").slice(0, 4).join(" ")}
                <br />
                <span className="gx-h2-26-b">
                  {text.split(" ").slice(4).join(" ")}
                </span>
              </h2>
            </div>
          </div>
          {type === "true" && (
            <div className="col-span-12 mb-2.5">
              <div className="gx-connectbank-logout">
                <button onClick={handleLogout}>
                  <img src={`${ICON_BASE_PATH}logouticon.svg`} alt="name" />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DialogSuccessfully;
